import { useEffect, useState } from 'react';

/**
 * Hook to access app options passed during mounting
 * @returns {Object} App options with helper methods
 */
export function useDinaExternalOptions() {
  const [options, setOptions] = useState(window.dinaExternalOptions || {});

  useEffect(() => {
    if (window.dinaExternalOptions) {
      setOptions(window.dinaExternalOptions);
    }

    const handleOptionsChange = () => {
      if (window.dinaExternalOptions) {
        setOptions(window.dinaExternalOptions);
      }
    };

    window.addEventListener('dinaExternalOptionsChanged', handleOptionsChange);

    return () => {
      window.removeEventListener('dinaExternalOptionsChanged', handleOptionsChange);
    };
  }, []);

  // Helper methods to access nested properties safely
  const getAssistantPublicConfig = () => options.assistant?.public || {};
  const getAssistantPublicCode = () => getAssistantPublicConfig().assistantCode || null;
  const isAssistantEmbedded = () => getAssistantPublicConfig().isEmbedded || false;

  return {
    ...options,
    getAssistantPublicConfig,
    getAssistantPublicCode,
    isAssistantEmbedded
  };
}
